const namespace = 'app/Workspace/Courseware';

export const COURSEWARE_META_INFO_GET_REQUEST = `${namespace}/COURSEWARE_META_INFO_GET_REQUEST`;
export const COURSEWARE_META_INFO_GET_SUCCESS = `${namespace}/COURSEWARE_META_INFO_GET_SUCCESS`;
export const COURSEWARE_META_INFO_GET_ERROR = `${namespace}/COURSEWARE_META_INFO_GET_ERROR`;
export const COURSEWARE_META_INFO_SET_REQUEST = `${namespace}/COURSEWARE_META_INFO_SET_REQUEST`;
export const COURSEWARE_META_INFO_SET_SUCCESS = `${namespace}/COURSEWARE_META_INFO_SET_SUCCESS`;
export const COURSEWARE_META_INFO_SET_ERROR = `${namespace}/COURSEWARE_META_INFO_SET_ERROR`;
